import script from "./flightSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./flightSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./flightSwitch.vue?vue&type=style&index=0&id=05a4a9b2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a4a9b2"]])

export default __exports__